/** Build kebab-case test id suffix from workflow step label */
export const workflowStepSlug = (label) =>
  String(label || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

/** Prefix helper for workflow progress components */
export const createWorkflowTestId = (prefix) => (suffix) => `${prefix}-${suffix}`;
